(() => {
  const storageKey = 'simply-drop-wishlist-v1';
  const read = () => {
    try {
      const value = JSON.parse(localStorage.getItem(storageKey) || '[]');
      return Array.isArray(value) ? value.filter((item) => item && item.id && item.url) : [];
    } catch (_) {
      return [];
    }
  };
  const write = (items) => {
    try {
      localStorage.setItem(storageKey, JSON.stringify(items));
      return true;
    } catch (_) {
      return false;
    }
  };
  const isSaved = (id) => read().some((item) => item.id === id);
  // Texte kommen aus den Locale-Dateien (sd.wishlist.*), gerendert in sections/sd-core-assets.liquid.
  const text = (name) => document.querySelector('[data-sd-core-i18n]')?.dataset[name] || '';

  const updateControls = () => {
    const items = read();
    document.querySelectorAll('[data-sd-wishlist-count]').forEach((count) => {
      count.textContent = String(items.length);
      count.classList.toggle('is-visible', items.length > 0);
    });
    document.querySelectorAll('[data-sd-wishlist-toggle]').forEach((button) => {
      const saved = items.some((item) => item.id === button.dataset.sdWishlistId);
      button.setAttribute('aria-pressed', String(saved));
      const label = button.querySelector('[data-sd-wishlist-label]');
      if (label) label.textContent = saved ? text('wishlistRemove') : text('wishlistAdd');
    });
  };

  const renderItems = () => {
    const target = document.querySelector('[data-sd-wishlist-items]');
    if (!target) return;
    const items = read();
    target.replaceChildren();
    if (!items.length) {
      const empty = document.createElement('p');
      empty.className = 'sd-wishlist-dialog__empty';
      empty.textContent = text('wishlistEmpty');
      target.append(empty);
      return;
    }
    const list = document.createElement('div');
    list.className = 'sd-wishlist-dialog__items';
    items.forEach((item) => {
      const row = document.createElement('div');
      row.className = 'sd-wishlist-dialog__item';
      if (item.image) {
        const image = document.createElement('img');
        image.src = item.image;
        image.alt = '';
        image.loading = 'lazy';
        row.append(image);
      } else {
        row.append(document.createElement('span'));
      }
      const link = document.createElement('a');
      link.href = item.url;
      link.textContent = item.title;
      row.append(link);
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'sd-wishlist-dialog__remove';
      remove.dataset.sdWishlistRemove = item.id;
      remove.textContent = text('wishlistRemoveItem');
      row.append(remove);
      list.append(row);
    });
    target.append(list);
  };

  const mountHeaderEntry = () => {
    const template = document.querySelector('template[data-sd-wishlist-entry]');
    const list = document.querySelector('.header__secondary-nav > ul');
    if (!template || !list || list.querySelector('.header__wishlist-link')) return;
    const entry = template.content.cloneNode(true);
    const cart = list.querySelector('.header__cart-link');
    list.insertBefore(entry, cart || null);
  };

  const open = () => {
    const dialog = document.querySelector('[data-sd-wishlist-dialog]');
    if (!dialog) return;
    renderItems();
    if (typeof dialog.showModal === 'function' && !dialog.open) dialog.showModal();
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-sd-wishlist-toggle]');
    if (toggle) {
      const id = toggle.dataset.sdWishlistId;
      const items = read();
      const index = items.findIndex((item) => item.id === id);
      if (index >= 0) items.splice(index, 1);
      else items.push({ id, title: toggle.dataset.sdWishlistTitle || text('wishlistProduct'), url: toggle.dataset.sdWishlistUrl, image: toggle.dataset.sdWishlistImage || '' });
      if (!write(items)) return;
      updateControls();
      return;
    }
    if (event.target.closest('[data-sd-wishlist-open]')) open();
    if (event.target.closest('[data-sd-wishlist-close]')) document.querySelector('[data-sd-wishlist-dialog]')?.close();
    const remove = event.target.closest('[data-sd-wishlist-remove]');
    if (remove) {
      if (!write(read().filter((item) => item.id !== remove.dataset.sdWishlistRemove))) return;
      renderItems();
      updateControls();
    }
  });

  const refresh = () => { mountHeaderEntry(); updateControls(); };
  document.addEventListener('DOMContentLoaded', refresh);
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:reorder', refresh);
})();

// Reopen Shopify's native consent preferences without changing consent ourselves.
document.addEventListener('click', async (event) => {
  const link = event.target.closest?.('a[href$="#sd-privacy-settings"]');
  if (!link || typeof window.privacyBanner?.showPreferences !== 'function') return;
  event.preventDefault();
  try {
    await window.privacyBanner.showPreferences();
  } catch (_) {
    window.location.assign(link.href.split('#')[0]);
  }
});
